/**
 * Created by lu on 2018/4/8.
 */
var nb = require('../../nb');
module.exports = nb.define({
    view:{
        'class':['banner-wrap',nb.bind('style')],
        $slot:'inner',
        style:{
            height:nb.bind('height')
        }
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/view/banner/Banner.js
// module id = 507
// module chunks = 6